import React, { HTMLAttributes, useEffect, useState, useCallback } from "react";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";

const { useTranslation } = Hooks;
import { getPasskeyCredential } from "../passkey";
import {
  post_passkeyAuthenticateBegin,
  post_passkeyAuthenticateFinish,
} from "../api/uaapi/uaa";
import { useStore } from "../store";
import { Button } from "antd";

import styles from "./index.module.scss";
import stylesCommon from "../common.module.scss";

// import imgVerifying from "./verifying.svg";
// import imgVerifying_dark from "./verifying-dark.svg";
// import imgVerifyFail from "./verifyFail.svg";
// import imgVerifyFail_dark from "./verifyFail-dark.svg";

import ImgVerifying from "./verifying";
import ImgVerifying_dark from "./verifying-dark";
import ImgVerifyFail from "./verifyFail";
import ImgVerifyFail_dark from "./verifyFail-dark";

interface Props extends HTMLAttributes<HTMLDivElement> {
  faCheckId: string;
  faBizType: number;
  successCallback?: (arg: any) => void;
  errorCallback?: (arg: any) => void;
  updateLoading?: (arg: boolean) => void;
  onSwitch?: () => void;
  switchLab?: string;
}

const Main: React.FC<Props> = ({
  faCheckId,
  faBizType,
  successCallback,
  errorCallback,
  updateLoading,
  onSwitch,
  switchLab,
  className,
}) => {
  const t = useTranslation();
  const { isDark } = useStore();

  const [loading, setLoading] = useState(true);

  const handleVerfiy = useCallback(() => {
    setLoading(true);
    post_passkeyAuthenticateBegin({
      data: { faCheckId, faBizType },
      headers: {
        "app-os": "web",
      },
      errorPop: true,
    })
      .then(async (result) => {
        const { requestId, authOptions } = result;
        const { err, data } = await getPasskeyCredential(authOptions);
        console.log("getPasskeyCredential", { err, data });
        if (err) {
          setLoading(false);
          // message.error(data.message);
          errorCallback && errorCallback({ err, data });
          return;
        }

        post_passkeyAuthenticateFinish({
          data: {
            faCheckId,
            faBizType,
            requestId,
            credential: data,
          },
          errorPop: true,
        })
          .then((data) => {
            console.log(data);
            successCallback && successCallback(data);
          })
          .catch((e) => {
            setLoading(false);
            errorCallback && errorCallback(e);
          });
      })
      .catch((e) => {
        setLoading(false);
        errorCallback && errorCallback(e);
      });
  }, [faCheckId, faBizType, successCallback]);

  useEffect(() => {
    handleVerfiy();
  }, []);
  useEffect(() => {
    updateLoading && updateLoading(loading);
  }, [loading]);

  return (
    <div className={cx(styles.main, className)}>
      {loading ? (
        <>
          {/*<img*/}
          {/*  src={isDark ? imgVerifying_dark : imgVerifying}*/}
          {/*  alt={"verifying icon"}*/}
          {/*/>*/}
          {isDark ? <ImgVerifying_dark/> : <ImgVerifying/>}
          <p>{t("@xt/Passkey.nowUsePasskey")}</p>
          <span>{t("@xt/Passkey.nowUsePasskeyTip")}</span>
        </>
      ) : (
        <>
          {/*<img*/}
          {/*  src={isDark ? imgVerifyFail_dark : imgVerifyFail}*/}
          {/*  alt={"verify fail icon"}*/}
          {/*/>*/}
          {isDark ? <ImgVerifyFail_dark/> : <ImgVerifyFail/>}
          <p>{t("@xt/Passkey.verifyFail")}</p>
          <span>{t("@xt/Passkey.verifyTimeoutTip")}</span>
          <div>
            <Button
              type="primary"
              size="large"
              block
              className={cx(styles.antdBtn)}
              onClick={handleVerfiy}
            >
              {t("@xt/Passkey.verifyAgain")}
            </Button>
            {!!onSwitch && (
              <button
                className={cx(
                  stylesCommon.btnTxt,
                  stylesCommon.primaryColor,
                  styles.btnSwitch
                )}
                onClick={onSwitch}
              >
                {switchLab || t("@xt/Passkey.switchVerifyMethod")}
              </button>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default Main;
